<template>
  <div></div>
</template>

<script>
import StopWatch from '../../utils/stopwatch'

export default {
  props: {
    lockAnswer: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      required: true,
    },
    isActive: {
      type: Boolean,
    },
    labelledBy: {
      type: String,
    },
    disableKeyboard: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return { userAnswer: undefined, stopWatch: null }
  },
  created() {
    let lapsedTime = 0

    try {
      lapsedTime = this.data.UserAnswer.lapsed_time
    } catch (err) {
      // Do nothing
    }

    this.stopWatch = new StopWatch(lapsedTime)
  },
  mounted() {
    this.toggleStopWatch(this.isActive)
  },
  computed: {
    questionId() {
      return this.data.Question.id
    },
    hasUserAnswer() {
      return !!this.userAnswer && this.userAnswer !== 0
    },
    isCorrect() {
      return !!(
        this.data &&
        this.data.UserAnswer &&
        this.data.UserAnswer.correct
      )
    },
  },
  methods: {
    /**
     * Should always be overwritten with a functional focus method in sub components.
     * This function does nothing but should always exist to prevent stuff from breaking
     * when a parent component tries to focus this component.
     */
    focus() {},
    /**
     * Should always be overwritten with a functional focus method in sub components.
     * This function does nothing but should always exist to prevent stuff from breaking
     * when a parent component tries to blur this component.
     */
    blur() {},
    toggleStopWatch(start) {
      if (start) {
        this.stopWatch.start()
      } else {
        this.stopWatch.pause()
      }
    },
  },
  watch: {
    userAnswer(userAnswer) {
      if (this.lockAnswer) {
        return
      }

      this.$emit(
        'answer',
        userAnswer,
        this.stopWatch ? this.stopWatch.getLapsedTime() : 0
      )
    },
    isActive(isActive) {
      this.toggleStopWatch(isActive)
    },
  },
}
</script>
